// extracted by mini-css-extract-plugin
export default {"recos":"H1-z","productCardOverride":"I1-z","rowHasBadge":"J1-z"};